import { Form, Formik } from "formik";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import EditUserProfile from "../../../Common/EditUserProfile";
import { setLoggedInUserProfileImage } from "../../../Redux/Actions/LoginActions";
import userService from "../../../services/user.service";
import { getFromLocalStorage } from "../../../utils/webStorage";
import validationSchema from "../../../Validation/ValidationSchemas";
import {
  openFailDialog,
  openSuccessPopup,
} from "../../../Redux/Actions/PopupActions";

const EditAthleteProfile = () => {
  const currentUserId = getFromLocalStorage("currentUserId");
  const schoolId = getFromLocalStorage("schoolId");
  const userRole = getFromLocalStorage("loginRole");
  const id = getFromLocalStorage("athleteId");
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [assignSportsList, setAssignSportsList] = useState([]);
  const [uploadId, setUploadId] = useState("");
  const [groupsData, setGroupsData] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [graduationYearText, setGraduationYearText] = useState("");
  const [loading, setLoading] = useState({
    buttonLoading: false,
    pageLoading: false,
    profileImageLoading: false,
  });
  const dispatch = useDispatch();
  const myref = useRef();

  const handleLogoUpload = (file) => {
    const data = new FormData();
    data.append("file", file);
    data.append("userId", currentUserId);
    setLoading((prevState) => ({
      ...prevState,
      profileImageLoading: true,
    }));
    userService
      .postLogoForAll(data)
      .then((res) => {
        const { id, filePath } = res.data.data;
        setImagePreviewUrl(filePath);
        setUploadId(id);
        setLoading((prevState) => ({
          ...prevState,
          profileImageLoading: false,
        }));
      })
      .catch((error) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
        setLoading((prevState) => ({
          ...prevState,
          profileImageLoading: false,
        }));
      });
  };

  useEffect(() => {
    getAllGroupsData(schoolId);
    fecthAthleteData();
  }, []);

  const fecthAthleteData = () => {
    setLoading((prevState) => ({
      ...prevState,
      pageLoading: true,
    }));
    userService
      .getAthleteDetails(id)
      .then((res) => {
        const data = res.data.data;
        if (data.uploadedLogo != null || "") {
          setUploadId(data.uploadedLogo.id);
          setImagePreviewUrl(data.uploadedLogo.filePath);
        }
        setGraduationYearText(data.graduationYear);
        const groupIds = data?.groupAthletes?.map((item) => item?.id);
        myref.current.setFieldValue("firstName", data.firstName);
        myref.current.setFieldValue("lastName", data.lastName);
        myref.current.setFieldValue("email", data.email);
        myref.current.setFieldValue("positionPlayed", data.positionPlayed);
        myref.current.setFieldValue("jerseyNumber", data.jerseyNumber);
        myref.current.setFieldValue("graduationYear", data.graduationYear);
        myref.current.setFieldValue("phoneNumber", data.phoneNumber);
        myref.current.setFieldValue("groupIds", groupIds);
        myref.current.setFieldValue(
          "instaUrl",
          data.instagramLink ? data.instagramLink : ""
        );
        myref.current.setFieldValue(
          "twitterUrl",
          data.twitterLink ? data.twitterLink : ""
        );

        const levels = [];
        const selectedGroupIds = [];
        for (var i = 0; i < data.groupAthletes.length; i++) {
          levels.push(data.groupAthletes[i]);
          selectedGroupIds.push(data.groupAthletes[i].id);
        }
        setSelectedGroup(data.groupAthletes);
        setLoading((prevState) => ({
          ...prevState,
          pageLoading: false,
        }));
      })
      .catch(() => {
        setLoading((prevState) => ({
          ...prevState,
          pageLoading: false,
        }));
      });
  };

  const handleSubmit = ({
    firstName,
    lastName,
    email,
    phoneNumber,
    positionPlayed,
    jerseyNumber,
    groupIds,
    graduationYear,
    instaUrl,
    twitterUrl,
  }) => {
    setLoading((prevState) => ({
      ...prevState,
      buttonLoading: true,
    }));
    userService
      .editAthleteDetails(
        firstName,
        lastName,
        email,
        phoneNumber,
        positionPlayed,
        graduationYear,
        uploadId,
        id,
        jerseyNumber,
        schoolId,
        groupIds,
        instaUrl,
        twitterUrl,
        "",
        ""
      )
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            profileImage: imagePreviewUrl,
            role: "athlete",
            firstName: firstName,
            lastName: lastName,
          };
          setLoggedInUserProfileImage(dispatch, obj);
          openSuccessPopup(dispatch, {
            successPopUp: {
              message: "Profile Updated Successfully",
              open: true,
              navigationLink: "/athleteprofiledetails",
            },
          });
        } else {
          openFailDialog(dispatch, {
            open: true,
            message: "Something Went Wrong",
          });
        }
        setLoading((prevState) => ({
          ...prevState,
          buttonLoading: false,
        }));
      })
      .catch((error) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
        setLoading((prevState) => ({
          ...prevState,
          buttonLoading: false,
        }));
      });
  };

  const onSelectOrRemoveGroups = (selectedList) => {
    const groupIds = selectedList.map((item) => item.id);
    myref.current.setFieldValue("groupIds", groupIds);
  };

  const getAllGroupsData = (schoolId) => {
    userService
      .getAllGroupsDropdown(schoolId)
      .then((response) => {
        let groupsDataTest = response.data.data.groupDropdownDetailsResponses;
        if (groupsDataTest != null) {
          let groupsData = [];
          for (let i = 0; i < groupsDataTest.length; i++) {
            let obj = {};
            obj["name"] = groupsDataTest[i].groupName;
            obj["id"] = groupsDataTest[i].id;
            groupsData.push(obj);
          }
          setGroupsData(groupsData);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  const getYearList = () => {
    let yearList = [];
    const date = new Date();
    let currentYear = date.getFullYear();
    for (let index = 1; index <= 10; index++) {
      yearList.push({ label: currentYear++ });
    }
    return yearList;
  };
  return (
    <Formik
      innerRef={myref}
      initialValues={{
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        positionPlayed: "",
        jerseyNumber: "",
        graduationYear: "",
        groupIds: [],
        instaUrl: "",
        twitterUrl: "",
      }}
      validationSchema={validationSchema.athleteFormValidation}
      onSubmit={(values) => handleSubmit(values)}
    >
      {(formik) => (
        <Form>
          <EditUserProfile
            userRole={userRole}
            handleSubmit={handleSubmit}
            imagePreviewUrl={imagePreviewUrl}
            handleLogoUpload={handleLogoUpload}
            id={id}
            groupsData={groupsData}
            selectedValues={selectedGroup}
            onSelectOrRemoveGroups={onSelectOrRemoveGroups}
            assignSportsList={assignSportsList}
            URL="/athleteprofiledetails"
            cancelType="Athlete Profile Edit"
            formik={formik}
            myref={myref}
            graduationYearText={graduationYearText}
            setGraduationYearText={setGraduationYearText}
            getYearList={getYearList}
            loading={loading}
          />
        </Form>
      )}
    </Formik>
  );
};

export default EditAthleteProfile;
